import HeroSection4 from './HeroSection4';

export default HeroSection4;